import { render } from "./AlertArea.vue?vue&type=template&id=2e999bce"
import script from "./AlertArea.vue?vue&type=script&lang=js"
export * from "./AlertArea.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__